import { useI18n } from 'hooks/useI18n';
import React from 'react';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../../shared/methodologyAnchor/MethodologyAnchor';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';
import { GENDERSALARYBYROLE } from '../Gender.constants';

const GenderSalaryByRole: React.FC = () => {
  const { t } = useI18n('developer-career-report-2023');

  const genderSalaryByRole = GENDERSALARYBYROLE.sort((a, b) =>
    a.female > b.female ? -1 : 1
  );

  return (
    <div>
      <StyledRecharts className="gender xAxisLabel">
        <ResponsiveContainer height={650} width="99%" minWidth={700}>
          <BarChart data={genderSalaryByRole}>
            <XAxis
              type="category"
              dataKey="role"
              tickLine={false}
              interval={0}
              angle={-60}
              textAnchor="end"
              height={200}
              axisLine={false}
            />
            <YAxis
              tickLine={false}
              width={60}
              axisLine={false}
              tickMargin={5}
              tickFormatter={(tick) => {
                return `€${tick}K`;
              }}
              padding={{ bottom: 5 }}
            />
            <Tooltip
              cursor={{ fill: '#d9ceff' }}
              labelStyle={{ display: 'none' }}
              separator=": "
              formatter={(value: number) => `€${value.toFixed(1)}K`}
              wrapperClassName="tooltip-x"
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ bottom: -5 }}
            />
            <Bar
              dataKey="female"
              name={t('mandecar23.gender.females')}
              barSize={12}
              radius={5}
              fill="#746FB3"
            ></Bar>
            <Bar
              dataKey="male"
              name={t('mandecar23.gender.males')}
              barSize={12}
              radius={5}
              fill="#1B9D76"
            />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default GenderSalaryByRole;
